// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import Criteria from '../state/criteria';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import MaintenancePlanModelCriteria from './maintenance-plan-model-criteria';
import MaintenancePlanPinCriteria from './maintenance-plan-pin-criteria';
import MaintenancePlanPlanNamesCriteria from './maintenance-plan-plan-names-criteria';
import MaintenancePlanServiceIntervalTypesCriteria from './maintenance-plan-service-interval-types-criteria';

const MaintenancePlanInputCriteria = props =>
    <div className='maintenance-plan-input-criteria'>
        <MaintenancePlanPlanNamesCriteria
            onHandlePlanNamesSelectChange={props.onHandlePlanNamesSelectChange}
            planName={props.criteria.planName}
            planNames={props.planNames}
        />
        <MaintenancePlanServiceIntervalTypesCriteria
            onHandleServiceIntervalTypesSelectChange={props.onHandleServiceIntervalTypesSelectChange}
            serviceIntervalType={props.criteria.serviceIntervalType}
            serviceIntervalTypes={props.serviceIntervalTypes}
        />
        <MaintenancePlanPinCriteria
            onHandlePinInputChange={props.onHandlePinInputChange}
            pin={props.criteria.pin}
        />
        <MaintenancePlanModelCriteria
            model={props.criteria.model}
            onHandleModelInputChange={props.onHandleModelInputChange}
        />
    </div>;

MaintenancePlanInputCriteria.displayName = 'MaintenancePlanInputCriteria';
MaintenancePlanInputCriteria.propTypes = {
    criteria: PropTypes.instanceOf(Criteria).isRequired,
    onHandleModelInputChange: PropTypes.func.isRequired,
    onHandlePinInputChange: PropTypes.func.isRequired,
    onHandlePlanNamesSelectChange: PropTypes.func.isRequired,
    onHandleServiceIntervalTypesSelectChange: PropTypes.func.isRequired,
    planNames: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    serviceIntervalTypes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired
};

export default MaintenancePlanInputCriteria;



// WEBPACK FOOTER //
// ./src/reports/maintenance-plan/components/maintenance-plan-input-criteria.js